/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable no-console */
import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import {
    Grid,
    Row,
    Column,
    Keyboard,
    Button,
    Heading,
    Form,
    FormInput,
    cls,
    HeaderCompound,
    SelectorButton,
    TranslationID
} from 'packages/components';
import { connect } from 'react-redux';
import Translator from '../../requests/apa/Translator';
import { autobind } from 'packages/core/lib';
import { PAYMENT_CARD } from '../utils/constants';
import store from '../../store';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import {
    showModal,
    AAF_MODAL_MONTHS,
    AAF_MODAL_YEARS,
    AAF_MODAL_STATES,
    AAF_MODAL_SUCCESS,
    AAF_MODAL_SUCCESS_SUSCRIPTION_PROD,
    AAF_MODAL_ERROR
} from '../../actions/modal';
import Utils, { enablePaymentMethodExperience } from '../../utils/Utils';
import Assets from '../../requests/apa/Asset';
import { apiPaywayConfirm, apiChangePaymentInfo, onPaymetSuccess, getWorkflow, getNumberLength, setInitialFocus, handleTypeModal, redirectPlayerOneClic, onFocusMultipleElements, filterInputValue, showError, isModalHide } from '../utils/Utils';
import UtilsClaroPagos from './utils';
import UtilsPagos from "../../utils/payway/UtilsPagos";
import Device from '../../devices/device';
import { validator, validlen } from './cardValidator';
import ConfirmationCVV from './ConfirmationCVV';
import ChangeCard from './ChangeCard';
import Spinner from '../../components/Spinner';
import './_styles.scss';
import { setMetricsEvent } from '../../actions/metrics';
import { CANCELAR_MEDIO_PAGO, METODO_DE_PAGO, COMPONENTE_TICKER, CLAROVIDEO, SUSCRIPCION_CLARO_VIDEO_REGISTRO, EXITOSO_MENSUAL_ANUAL_METODO_DE_PAGO, ADD_ON_REGISTRO, COMPONENT_SUSCRIPCION, COMPRAS_VCARD, ADD_ON_VCARD, ADD_ON_TV } from '../../authentication/utils/constansMetrics';
import { MAP_CREDIT_CARD } from './constants';
import {GA4} from 'src/utils/trackers/GA4';
import {PAYMENT_METHOD_CREDIT_CARD} from 'src/utils/trackers/GA4Constants';
import AAF from '../../AAF/AAF';

enum Steps {
    STEP_CARD = 'INSERT_CARD',
    STEP_DIRECTION = 'INSERT_DIRECTION',
}
interface IStepsValue {
    [key: string]: string | undefined;
    placeholderCard?: string;
    placeholderName?: string;
    placeholderMonth?: string;
    placeholderYear?: string;
    placeholderCvv?: string;
    placeholderDir?: string;
    placeholderCity?: string;
    placeholderState?: string;
    placeholderZip?: string;
    placeholderTel?: string;
}

interface ICardState {
    step: string;
    form: {
        image_card: string;
        card?: string;
        name?: string;
        month?: string;
        year?: string;
        cvv?: string;
        direction?: string;
        city?: string;
        state?: string;
        zip?: string;
        telephone?: string;
    };
    errors: {
        card?: boolean;
        name?: boolean;
        month?: boolean;
        year?: boolean;
        cvv?: boolean;
        direction?: boolean;
        city?: boolean;
        state?: boolean;
        zip?: boolean;
        telephone?: boolean;
    };
    errorSelectMonth: string;
    errorSelectYear: string;
    errorFromBackend: string;
    errorSelectState: string;
    showTooltipSuccess: boolean;
    pbi: any;
    worflowstart: any;
    selectedPaymentMethod: string;
    type: number;
    wfs: any;
    isCVV: boolean;
    element: any;
    isLoading: boolean;
    card_type?: string;
}

class PaymentCard extends Component<RouteComponentProps, ICardState> {
    public titleForm: string = Translator.get('claropagosgate_access_title_label', 'Agregar Tarjeta');
    public textNext: string = Translator.get('claropagosgate_access_option_button_next', 'Siguiente');
    public textCancel: string = Translator.get('claropagosgate_access_option_button_cancel', 'Cancel');
    private isValidForm: boolean;
    public keys = (Device.getDevice() && Device.getDevice().getKeys()) || null;
    private translations: Record<TranslationID, string> = {
        'form_tooltip_empty_label_validation': Translator.get('form_tooltip_empty_label_validation', 'Debes completar este campo para continuar.'),
        'form_tooltip_invalidPan_label_validation': Translator.get('form_tooltip_invalidPan_label_validation', 'El número de tarjeta es inválido, por favor verificalo.'),
        'form_tooltip_lengthPan_label_validation': Translator.get('form_tooltip_lengthPan_label_validation', 'Debes ingresar entre 13 y 18 números. Verifica tu tarjeta.')
    };
    private from: string = '';
    private creditCardImage: string = '';
    private isNewModalTicket: boolean = false;

    public months = [
        { id: 1, name: 'Enero' },
        { id: 2, name: 'Febrero' },
        { id: 3, name: 'Marzo' },
        { id: 4, name: 'Abril' },
        { id: 5, name: 'Mayo' },
        { id: 6, name: 'Junio' },
        { id: 7, name: 'Julio' },
        { id: 8, name: 'Agosto' },
        { id: 9, name: 'Septiembre' },
        { id: 10, name: 'Octubre' },
        { id: 11, name: 'Noviembre' },
        { id: 12, name: 'Diciembre' }
    ];

    public years: any[] = [];
    public year = Utils.now(true).year();
    public states = Utils.getApaMetadataKey('states', null);
    public stateOptions: any = [];

    constructor(props: RouteComponentProps) {
        super(props);
        const { location: { state = {} } = {} } = props || {};
        this.from = state?.from;
        this.state = {
            step: Steps.STEP_CARD,
            form: {
                image_card: '',
                card: '',
                name: '',
                month: '',
                year: '',
                cvv: '',
                direction: '',
                city: '',
                state: '',
                zip: '',
                telephone: '',
            },
            errors: {
                card: false,
                name: false,
                month: false,
                year: false,
                cvv: false,
                direction: false,
                city: false,
                state: false,
                zip: false,
                telephone: false
            },
            errorFromBackend: '',
            errorSelectMonth: '',
            errorSelectYear: '',
            errorSelectState: '',
            showTooltipSuccess: false,
            pbi: {},
            worflowstart: {},
            selectedPaymentMethod: '',
            type: 0,
            wfs: {},
            isCVV: false,
            element: '',
            isLoading: false,
            card_type: ''
        };
        this.isNewModalTicket = this.getNewStylesModalPymentMethod();
    }

    private getNewStylesModalPymentMethod(): boolean {
        let newStylesModalPaymentMethod = Utils.getRegionaliazedMetadata('new_styles_modal_payment_method', '{"default":{"enable":false},"mexico":{"enable":false}}');
        return newStylesModalPaymentMethod && newStylesModalPaymentMethod.enable;
    }

    public componentDidMount() {
        document && document.removeEventListener('keydown', this.onKeyPress, true);
        document && document.addEventListener('keydown', this.onKeyPress, true);
        document && document.addEventListener('sn:enter-up', this.enterUpHandler, true);
        if (isModalHide()) {
            setInitialFocus('.aaf_form-group-input-element .aaf_focusable', false);
        }
        const selectedPaymentMethod = this.props.location.state.method;
        const { location: { state: { pbi, type, worflowstart } } } = this.props;
        let { isCVV } = this.state;
        if (pbi && worflowstart && type) {
            const wfs = getWorkflow(selectedPaymentMethod, worflowstart);
            if (wfs?.paymentMethodData && wfs?.paymentMethodData?.cardsData) {
                isCVV = true;
            }
            this.setState({ pbi, worflowstart, selectedPaymentMethod, type, wfs, isCVV });
        }
        for (let y = this.year; y < this.year + 8; y++) {
            this.years.push({ id: y, name: y });
        }
        if (this.states) {
            this.states = Object.keys(this.states).map((x) => {
                return { name: x, id: this.states[x] };
            });
        }

        this.stateOptions = this.states
            ? this.states
            : [
                { name: 'Aguascalientes', id: 'AG' },
                { name: 'Baja California', id: 'BC' },
                { name: 'Baja California Sur', id: 'BS' },
                { name: 'Campeche', id: 'CM' },
                { name: 'Chiapas', id: 'CS' },
                { name: 'Chihuahua', id: 'CH' },
                { name: 'Coahuila', id: 'CO' },
                { name: 'Colima', id: 'CL' },
                { name: 'Distrito Federal', id: 'DF' },
                { name: 'Durango', id: 'DG' },
                { name: 'Guanajuato', id: 'GT' },
                { name: 'Guerrero', id: 'GR' },
                { name: 'Hidalgo', id: 'HG' },
                { name: 'Jalisco', id: 'JC' },
                { name: 'Estado de México', id: 'ME' },
                { name: 'Michoacán', id: 'MN' },
                { name: 'Morelos', id: 'MS' },
                { name: 'Nayarit', id: 'NT' },
                { name: 'Nuevo León', id: 'NL' },
                { name: 'Oaxaca', id: 'OC' },
                { name: 'Puebla', id: 'PL' },
                { name: 'Querétaro', id: 'QO' },
                { name: 'Quintana Roo', id: 'QR' },
                { name: 'San Luis Potosí­', id: 'SP' },
                { name: 'Sinaloa', id: 'SL' },
                { name: 'Sonora', id: 'SR' },
                { name: 'Tabasco', id: 'TC' },
                { name: 'Tamaulipas', id: 'TS' },
                { name: 'Tlaxcala', id: 'TL' },
                { name: 'Veracruz', id: 'VZ' },
                { name: 'Yucatán', id: 'YN' },
                { name: 'Zacatecas', id: 'ZS' },
            ];
    }

    public componentWillUnmount(): void {
        document && document.removeEventListener('keydown', this.onKeyPress, true);
        document && document.removeEventListener('sn:enter-up', this.enterUpHandler, true);
    }

    public componentDidUpdate(): void {
        this.onFocus();
    }

    public enterUpHandler = (e: any) => {
        const el: any = e.target;
        if (el.className.includes('aaf_focusable')) {
            this.setState({ element: e.target });
        }
    };

    private retryGetDataWorkflow(pbi: any, cpgs_user: boolean = false): void {

        const { linkworkflowstart, offerid, groupId } = pbi;
        const { history } = this.props;

        UtilsClaroPagos.getWorkflowstart(linkworkflowstart, groupId, offerid, cpgs_user).then((resp) => {
            const ws = UtilsClaroPagos.parseWorkFlowStart(resp.response);
            this.setState({ worflowstart: ws });
            this.handleSubmit();
        }).catch((err) => {
            // Anteriormente se daba un back en el history, enviando el mensaje de error. Pero aun no se define como será aquí­.
        });
    }

    private getTextBySteps(attribute: string): string {
        const { step } = this.state;
        let result: IStepsValue = {
            placeholderCard: Translator.get('claropagosgate_number_placeHolder_textfield', 'Ingresa tu número de tarjeta'),
            placeholderName: Translator.get('claropagosgate_holder_placeHolder_textfield', 'Ingresa el nombre de la tarjeta'),
            placeholderMonth: Translator.get('claropagosgate_month_placeHolder_select', 'Mes'),
            placeholderYear: Translator.get('claropagosgate_year_placeHolder_select', 'Año'),
            placeholderCvv: Translator.get('claropagosgate_cvv_placeHolder_select', 'CVV'),
        };

        if (step === Steps.STEP_DIRECTION) {
            result = {
                placeholderDir: Translator.get('claropagosgate_address_placeHolder_textfield', 'Ingresa tu dirección'),
                placeholderCity: Translator.get('claropagosgate_city_placeHolder_textfield', 'Ingresa tu ciudad'),
                placeholderState: Translator.get('claropagosgate_state_placeHolder_select', 'Estado'),
                placeholderZip: Translator.get('claropagosgate_zipCode_placeHolder_textfield', 'C.P.'),
                placeholderTel: Translator.get('claropagosgate_telephoneNumber_placeHolder_textfield', 'Ingresa tu teléfono'),
            };
        }

        return result[attribute] ?? '';
    }

    @autobind
    private handleChange(value: string, type: string): void {
        const { form } = this.state;
        let { form: { image_card, cvv, name, telephone }, errorFromBackend } = this.state;
        this.isValidForm = value !== '';
        if (value === '') {
            image_card = '';
            errorFromBackend = '';
        }
        if (validlen(value) || cvv?.length === 3 || name !== '' || telephone?.length === getNumberLength()) {
            errorFromBackend = '';
        }
        if (type === 'card' && value.length === 4) {
            const ImageCardType = validator(value) || '';
            this.setCreditCardImage(ImageCardType);
            image_card = this.getImageCardType(ImageCardType);
        }
        const filteredValue = filterInputValue(value, type);
        this.setState({ form: { ...form, [type]: filteredValue, image_card }, errorFromBackend } as ICardState);

    }



    private setCreditCardImage(value: string): void{
        const card_type = MAP_CREDIT_CARD.find((creditCard)=>{return creditCard.name === value});
        if (card_type) {
            const assetName = `claropagosgate_cardType_icon_${card_type.id}`;
            this.creditCardImage =  Assets.get(assetName, '');
        }
    }

    private getCreditCardImage(): string {
        return this.creditCardImage;
    }

    private getImageCardType(value: string): string {
        let asset = '';
        if (value) {
            const assetName = `claropagosgate_number_icon_${value.toLowerCase()}`;
            asset = Assets.get(assetName);
            this.setState({ card_type: value });
        }
        return asset;
    }

    private handleNextStep = (): void => {
        const { step } = this.state;

        if (step === Steps.STEP_CARD) {
            this.validatorFields();
        } else {
            this.handleSubmit();
        }
    };

    @autobind
    private sendGA4Metric() {
        const gA4 = new GA4();
        gA4.sendAddPaymentMethodEvent(PAYMENT_METHOD_CREDIT_CARD);
    }

    private validatorFields = (): void => {
        const {
            form: {
                card,
                name,
                month,
                year,
                cvv,
                direction,
                city,
                state,
                zip,
                telephone },
            errors,
            step
        } = this.state;
        if (step === Steps.STEP_CARD) {
            if (card?.length === 0 || card?.length === 1 || !validlen(card) || validator(card) === undefined) {
                const error = card?.length === 0 || card?.length === 1 ? this.translations['form_tooltip_empty_label_validation'] : validator(card) === undefined ? this.translations['form_tooltip_invalidPan_label_validation'] : this.translations['form_tooltip_lengthPan_label_validation'];
                this.setState({ errors: { card: false, name: true, cvv: true }, errorFromBackend: error });
            } else if (name?.length === 0 || name?.length === 1) {
                this.setState({ errors: { name: false, card: true, cvv: true }, errorFromBackend: this.translations['form_tooltip_empty_label_validation'] });
            } else if (!month) {
                this.setState({ errors: { ...errors, month: false }, errorSelectMonth: this.translations['form_tooltip_empty_label_validation'] });
            } else if (!year) {
                this.setState({ errors: { ...errors, year: false }, errorSelectYear: this.translations['form_tooltip_empty_label_validation'] });
            } else if (cvv?.length === 0 || cvv?.length === 1) {
                this.setState({ errors: { cvv: false, card: true, name: true }, errorFromBackend: this.translations['form_tooltip_empty_label_validation'] });
            }
        } else {
            if (direction?.length === 0 || direction?.length === 1) {
                this.setState({ errors: { direction: false, city: true, zip: true, telephone: true }, errorFromBackend: this.translations['form_tooltip_empty_label_validation'] });
            } else if (city?.length === 0 || city?.length === 1) {
                this.setState({ errors: { direction: true, city: false, zip: true, telephone: true }, errorFromBackend: this.translations['form_tooltip_empty_label_validation'] });
            } else if (!state) {
                this.setState({ errors: { ...errors, state: false }, errorSelectState: this.translations['form_tooltip_empty_label_validation'] });
            } else if (zip?.length === 0 || zip?.length === 1) {
                this.setState({ errors: { direction: true, city: true, zip: false, telephone: true }, errorFromBackend: this.translations['form_tooltip_empty_label_validation'] });
            } else if (telephone?.length === 0 || telephone?.length === 1) {
                this.setState({ errors: { direction: true, city: true, zip: true, telephone: false }, errorFromBackend: this.translations['form_tooltip_empty_label_validation'] });
            }
        }
        if (validlen(card) && validator(card) !== undefined && name && month && year && cvv && step === Steps.STEP_CARD) {
            setInitialFocus('.aaf_form-group-input-element .aaf_focusable');
            this.isValidForm = false;
            this.setState({ step: Steps.STEP_DIRECTION, errorFromBackend: '' });
        }
    }

    private handleShowCalendar = (type: string): void => {
        const { showModal } = this.props;
        let typeModal: string = '';
        let options: any = [];
        if (type === 'months') {
            typeModal = AAF_MODAL_MONTHS;
            options = this.months;
        } else {
            typeModal = AAF_MODAL_YEARS;
            options = this.years;
        }
        const classButton: string = type === 'months' ? 'month' : 'year';
        const modal = {
            modalType: typeModal,
            modalProps: {
                device: Device.getDevice().getPlatform(),
                options,
                service: (m: any) => {
                    this.handleModal(m, type);
                    setInitialFocus(`.aaf_selector-button-${classButton}`);
                },
            },
        };
        showModal(modal);
    };

    private getCardTypeKey(card: string | undefined): string {
        let type = '0';
        if (card) {
            switch (card) {
                case 'VISA':
                    type = '1';
                    break;
                case 'MASTERCARD':
                    type = '2';
                    break;
                case 'AMERICAN EXPRESS':
                    type = '3';
                    break;
                default:
                    type = '0';
            }
        }
        return type;
    }

    private handleShowStates = (): void => {
        const { showModal } = this.props;
        const modal = {
            modalType: AAF_MODAL_STATES,
            modalProps: {
                device: Device.getDevice().getPlatform(),
                options: this.stateOptions,
                service: (m: any) => {
                    this.handleModal(m, 'states');
                    setInitialFocus('.aaf_selector-button-state');
                },
            },
        };
        showModal(modal);
    };

    private getPlanName(producttype: any){
        return producttype.replace('_', ' ')
    }

    private handleSubmit = (): void => {
        const { form, pbi, selectedPaymentMethod, wfs, card_type } = this.state;
        const { card, city, cvv, direction, month, name, state, telephone, year, zip } = form;
        const fingerprint = DeviceStorage.getItem("HKS") + new Date().toTimeString().split(' ')[0];
        const { history, location: { state: { replace } } } = this.props;
        const { paymentMethodData: { account = '', cardsData = [] } } = wfs;
        const cardTypeKey = this.getCardTypeKey(card_type);
        this.validatorFields();
        if (card && city && cvv && direction && month && name && state && telephone && year && zip && fingerprint) {
            const params = {
                address: direction,
                cardNumber: card,
                cardType: cardTypeKey,
                city,
                expiryDate_MM: month,
                expiryDate_YY: year?.slice(2,4),
                name,
                securityCode: cvv,
                states: state,
                telefono: telephone,
                zipCode: zip,
                fingerprint,
            };

            this.createClientFail = this.createClientFail.bind(this);
            this.createCardFail = this.createCardFail.bind(this);

            let buyConfirmParams = {
                clientResp: {},
                client_id: wfs && wfs.paymentMethodData && wfs.paymentMethodData.account ? wfs.paymentMethodData.account : '',
                wfs,
                cardTypeKey,
                fingerprint,
                pbi,
                selectedPaymentMethod,
                history,
                cardResp: {}
            };
            this.setMetricsSuscription(pbi, wfs);
            try {
                Utils.scriptCyberSource();
            } catch (e) {
                console.error('Error al cargar script CyberSource', e.message)
            }
            this.setState({ isLoading: true });
            if (replace) {
                this.updateCard(cardsData[0].token, params).then((updateData) => {
                    this.setState({ isLoading: false });
                    const { data: { tarjeta: { token = '' } } } = updateData;
                    const formParams = {
                        cliente_id: account,
                        card_type: cardsData[0].card_type,
                        old_token: cardsData[0].token,
                        new_token: token,
                        device_fingerprint: fingerprint
                    }
                    apiChangePaymentInfo({ formParams });
                }).catch((error) => {
                    this.setState({ isLoading: false });
                    showError(error);
                });
            } else {
                if (!buyConfirmParams.client_id) {
                    this.createClient(params).then((clientResp: any) => {
                        buyConfirmParams.clientResp = clientResp;
                        this.createCard(clientResp.data.cliente.id, params).then((cardResp) => {
                            this.setState({ isLoading: false });
                            buyConfirmParams.cardResp = cardResp;
                            this.buyConfirmProcess(buyConfirmParams);
                        }).catch((error) => {
                            showError(error);
                            this.setState({ isLoading: false });
                            this.createCardFail(error, buyConfirmParams);
                        });
                    }).catch((error) => {
                        showError(error);
                        this.setState({ isLoading: false });
                        this.createClientFail(error, pbi);
                    });
                } else {
                    this.createCard(buyConfirmParams.client_id, params).then((cardResp) => {
                        this.setState({ isLoading: false });
                        buyConfirmParams.cardResp = cardResp;
                        this.buyConfirmProcess(buyConfirmParams);

                    }).catch((error) => {
                        this.setState({ isLoading: false });
                        this.createCardFail(error, buyConfirmParams);
                        this.setState({ isLoading: false });
                    });
                }
            }
        }
    };

    private buyConfirmProcess(buyConfirmParams: any) {
        const { cardResp, wfs, client_id, clientResp, cardTypeKey, fingerprint, selectedPaymentMethod, pbi, pbi: { isSubscription } } = buyConfirmParams;
        let formParams = {
            client_id: client_id || clientResp.data.cliente.id,
            card_token: cardResp.data.tarjeta.token,
            card_type: cardTypeKey,
            device_fingerprint: fingerprint,
        }
        let cb = isSubscription ? (resp: object) => this.redirectAddon(resp) : (resp: object) => this.redirectVCard(resp);
        this.sendGA4Metric();

        apiPaywayConfirm({ pbi, wfs, formParams })
            .then((resp) => {
                this.setMetricsSeason(pbi, wfs);
                onPaymetSuccess(resp, pbi, wfs, selectedPaymentMethod, cb);
            })
            .catch(err => {
                showError(err);
            });

    }

    private setMetricsSeason(pbi: any, wfs: any){
        const isSeason =  wfs.producttype.toLowerCase().indexOf('season') > 0 ? true : false;
        const isEpisode =  wfs.producttype.toLowerCase().indexOf('episode') > 0 ? true : false;
        const episode = pbi.oneofferdesc.split(' ');
        const { worflowstart: {contentInfo}, } = this.state;
        if(contentInfo){
            if(isSeason) {
                Utils.sendMetric(this.props,  (contentInfo.contentTitle.toLowerCase()).concat(' - ',  wfs?.gatewaytext.toLowerCase()),contentInfo.contentOriginalTitle.toLowerCase(), COMPRAS_VCARD);
            } else if(isEpisode) {
                Utils.sendMetric(this.props,  (`${episode[1]} ${episode[2]}`).concat(' - ',  wfs?.gatewaytext.toLowerCase()),contentInfo.contentOriginalTitle.toLowerCase(), COMPRAS_VCARD);
            }else {
                Utils.sendMetric(this.props,  (pbi.oneofferdesc.toLowerCase()).concat(' - ',  wfs?.gatewaytext.toLowerCase()),contentInfo.contentTitle.toLowerCase(), COMPRAS_VCARD);
            }
        }
    }

    private setMetricsSuscription(pbi: any, wfs: any){
        if(!pbi.isSubscription) return;
        const productType = wfs.producttype.split('_');
        const eventLabel = this.getPlanName(pbi.producttype);
        const metricsHistory = this.props.location.state.metricsHistory;
        let eventActionText = '';
        if(metricsHistory){
            eventActionText = metricsHistory.toLowerCase().includes('vcard') ? ADD_ON_VCARD : (metricsHistory.toLowerCase().includes('tv') ? ADD_ON_TV : ADD_ON_REGISTRO) ;
        } else{
            eventActionText = ADD_ON_REGISTRO;
        }


        if(pbi.family === CLAROVIDEO) {
            Utils.sendMetric(this.props,  SUSCRIPCION_CLARO_VIDEO_REGISTRO, EXITOSO_MENSUAL_ANUAL_METODO_DE_PAGO.concat(productType[1].toLowerCase()).concat(' - ',  wfs.gatewaytext.toLowerCase()), COMPONENT_SUSCRIPCION);
        }else {
            Utils.sendMetric(this.props,  eventActionText, EXITOSO_MENSUAL_ANUAL_METODO_DE_PAGO.concat(eventLabel.toLowerCase()).concat(' - ',  wfs.gatewaytext.toLowerCase()), COMPONENT_SUSCRIPCION);
        }
    }

    @autobind
    private showTicket(resp: any, groupId: string, islive: boolean, account: string) {
        const { showModal } = this.props;
        const { type, worflowstart: { contentInfo }, pbi, pbi: { producttype, currency, price, family, periodicity, frequency }, selectedPaymentMethod } = this.state;
        const region = DeviceStorage.getItem('region');
        const { response: { end_date: { day = '', month = '', year = '' } = {}, payway_token = '' } = {} } = resp || {};
        const payDate = `${day} ${month} ${year}`;

        const data = {
            pbi,
            total: UtilsPagos.getTotalAndPeriodicity(currency, price, periodicity),
            duration: `${Translator.get(periodicity, '')}`,
            frequency: frequency,
            days: Translator.get(`bonus_${producttype}`),
            content: Translator.get(`Ticket_Transaccion_TextoDescripcion_${producttype}`, ''),
            payment_method: Translator.get(`ticket_subscription_${selectedPaymentMethod}_label`, ''),
            img_largeSub: Assets.get(`${region}_transactional_${family}_poster`, ''),
            img_large: contentInfo?.contentImageMedium,
            providerImage: Assets.get(`transactional_${family}_logo`),
            title: contentInfo?.contentTitle || '',
            type: type,
            from: this.from
        };

        const newData = handleTypeModal({ ...data, next_pay: payDate});

        const modal = {
            modalType: this.isNewModalTicket ? AAF_MODAL_SUCCESS : AAF_MODAL_SUCCESS_SUSCRIPTION_PROD,
            modalProps: {
                data: {...newData, creditCardImage: this.getCreditCardImage(), account},
                handlePlay: () => this.from ? this.handleAddOn(resp) : this.handlePlay(groupId, payway_token, islive),
                handleVCard: () => this.handleVCard(groupId),
                payment_methods_experience: enablePaymentMethodExperience()
            }
        };
        showModal(modal);
    }

    private redirectAddon(resp: any): void {
        const { pbi: { groupId = '', oneoffertype = '', islive = false }, worflowstart: { selectedPaymentMethod } } = this.state;
        const isOneClicFlow = groupId === '' ? false : true;
        const oneClicKey = `${oneoffertype}_${selectedPaymentMethod}`;
        if (UtilsPagos.oneClicBuyHiddeConfirm(isOneClicFlow, oneClicKey)) {
            if (UtilsPagos.oneClicBuyRedirectPlayer(isOneClicFlow, oneClicKey)) {
                setTimeout(() => {
                    const { history } = this.props;
                    const nav = Utils.getApaMetadataKey('links_nav_configuration', Utils.mock_links_nav_configuration());
                    if (islive) {
                        if(nav && nav.home) {
                            history.replace(`/node/${nav.home}`);
                        }
                    }
                    else if (groupId) {
                        this.handleVCard(groupId);
                    }
                }, 0);
            }
            else {
                // este caso aplica cuando no se tiene activado el one clic muestra modal de compra exitosa
                const { response: { paymentMethodData: {account = '' } = {} } = {} } = resp || {};
                this.showTicket(resp, groupId, islive, account);
            }
        } else {
            // aplica para plan selector y vcard cuando no hay one clic
            const { response: { paymentMethodData: {account = '' } = {} } = {} } = resp || {};
            this.showTicket(resp, groupId, islive, account);
        }
    }

    private redirectVCard(resp?: any): void {
        const { pbi: { groupId = '', oneoffertype = '', islive = false }, worflowstart: { selectedPaymentMethod } } = this.state;
        const isOneClicFlow = groupId === '' ? false : true;
        const oneClicKey = `${oneoffertype}_${selectedPaymentMethod}`;
        const { response: { paymentMethodData: {account = '' } = {} } = {} } = resp || {};
        if (UtilsPagos.oneClicBuyHiddeConfirm(isOneClicFlow, oneClicKey)) {
            if (UtilsPagos.oneClicBuyRedirectPlayer(isOneClicFlow, oneClicKey)) {
                setTimeout(() => {
                    const { history } = this.props;
                    const nav = Utils.getApaMetadataKey('links_nav_configuration', Utils.mock_links_nav_configuration());
                    if (islive) {
                        if(nav && nav.home) {
                            history.replace(`/node/${nav.home}`);
                        }
                    }
                    else if (groupId) {
                        this.handleVCard(groupId);
                    }
                }, 0);
            }
            else {
                // este caso aplica cuando no se tiene activado el one clic muestra modal de compra exitosa
                this.showTicket(resp, groupId, islive, account);
            }
        } else {
            // aplica para plan selector y vcard cuando no hay one clic
            this.showTicket(resp, groupId, islive, account);
        }
    }

    private handleAddOn(resp: any) {
        const { history } = this.props;
        let node = 'homeuser';
        if(AAF.AdsUtils.isAdsEnable()){
            node = Utils.getNodeAddOnAdvertising(resp);
        }else{
            const { nodes } = this.props;
            node = Utils.getNodeAddOn(resp, nodes)
        }
            history.replace(`/node/${node}`);
    }

    @autobind
    private handlePlay(groupId: string, payway_token: string, islive: boolean) {
        if (groupId) {
            redirectPlayerOneClic(groupId, islive, payway_token, () => {
                this.handleVCard(groupId);
            })
        }
    }

    @autobind
    private handleVCard(groupId: string) {
        if (groupId) {
            const { history } = this.props;
            history.replace(`/vcard/${groupId}`);
        }
    }
    private createCard(client_id: any, params: any) {

        const action = 'create_card';

        const card = {
            nombre: params.name,
            pan: params.cardNumber,
            cvv2: params.securityCode,
            expiracion_mes: params.expiryDate_MM,
            expiracion_anio: params.expiryDate_YY,
            direccion: {
                linea1: params.address,
                cp: params.zipCode,
                telefono: {
                    numero: Number(params.telefono),
                },
                ciudad: params.city,
                estado: params.states,
                pais: UtilsClaroPagos.getCountryCode(),
            },
            cliente_id: client_id,
            default: true,
            cargo_unico: true
        };

        const config = UtilsClaroPagos.getConfiguration(action);
        const authorization = Utils.Base64Decode(config.header.authorization);

        return UtilsClaroPagos.generalRequest(config.server_url, card, authorization);

    }

    private updateCard(client_id: string, params: any) {
        const { wfs } = this.state;
        const { paymentMethodData: { cardsData = [] } } = wfs;
        const action = 'update_card';
        const config = UtilsClaroPagos.getConfiguration(action);
        const authorization = Utils.Base64Decode(config.header.authorization);
        const url = config.server_url.replace('{token}', cardsData[0]?.token);

        const updataCardData =
        {
            nombre: params.name,
            pan: params.cardNumber,
            expiracion_mes: params.expiryDate_MM,
            expiracion_anio: params.expiryDate_YY,
            cvv2: params.securityCode,
            telefono: {
                numero: params.telefono
            },
            direccion: {
                linea1: params.address,
                cp: params.zipCode,
                ciudad: params.city,
                estado: params.states,
                pais: UtilsClaroPagos.getCountryCode(),
            },
            cliente_id: client_id,
            default: true
        }
        return UtilsClaroPagos.generalRequest(url, updataCardData, authorization, 'PUT');
    }

    private createClient(params: any) {
        const action = 'create_client';
        const state = store.getState();

        const client = {
            id_externo: state.user.user_id,
            nombre: state.user.firstname,
            apellido_paterno: state.user.lastname,
            email: state.user.email,
            telefono: {
                numero: params.telefono
            },
            direccion: {
                linea1: params.address,
                cp: params.zipCode,
                ciudad: params.city,
                estado: params.states,
                pais: UtilsClaroPagos.getCountryCode(),
            },
            device_fingerprint: params.fingerprint,
        };

        const config = UtilsClaroPagos.getConfiguration(action);
        const authorization = Utils.Base64Decode(config.header.authorization);

        return new Promise((resolve, reject) => {
            UtilsClaroPagos.generalRequest(config.server_url, client, authorization).then((response) => {
                resolve(response)
            }).catch(error => {
                reject(error);
            });
        })

    }

    private createClientFail(err: any, pbi: any) {
        if (err.completeError && err.completeError.error && err.completeError.error.code && err.completeError.error.code === 409) {
            //El cliente ya existe en claro pagos (email,  usuario claro video). Regresar al paso 3 e invocar el API payway/workflowstart enviándole como parámetro adicional cpgs_user igual a true.
            this.retryGetDataWorkflow(pbi, true);
            return;
        }
    }

    private createCardFail(err: any, buyConfirmParams: any) {
        let { wfs } = buyConfirmParams;
        const { showModal } = this.props;
        if (err.completeError.error.code === 409) {
            //Porque la tarjeta ya existe en claro pagos (nombre,  pan, cvv, mes de expiración, año de expiración, cliente claro pagos).
            //Recuperar los datos de la tarjeta retornados por payway / workflowstart y continuar al paso 9.

            const cardsData = wfs.paymentMethodData.cardsData;

            //Dice Lalo que se toma el primer elemento del arreglo y que en un futuro cambiara esta estructura con un default.
            buyConfirmParams.cardResp.card_token = (cardsData && cardsData[0] && cardsData[0].token);
            this.buyConfirmProcess(buyConfirmParams);
            return;
        }

        const message = Translator.get('claropagos_genericerror', "Estimado usuario, por el momento no podemos atender tu solicitud, intenta m\u00e1s tarde.");
        const modal = {
            modalType: AAF_MODAL_ERROR,
            modalProps: {
                callback: () => { },
                message,
                content: err
            }
        };

        showModal(modal);
    }

    private getMonthString = (monthId: any): string => {
        const month = this.months.find((m) => {
            return m.id === parseInt(monthId);
        });
        return month ? month.name : '';
    }

    private getStateString = (stateId: string): string => {
        const state = this.stateOptions.find((s: any) => {
            return s.id === stateId;
        });
        return state ? state.name : '';
    }

    private handleModal = (id: any, select: any): void => {
        const { form } = this.state;
        let { month, year, state } = form;
        this.isValidForm = true;
        switch (select) {
            case 'months':
                for (let m in this.months) {
                    if (this.months[m].id === id) {
                        month = id < 10 ? '0' + id : id.toString();
                    }
                }
                break;
            case 'years':
                for (let y in this.years) {
                    if (this.years[y].id === id) {
                        year = this.years[y].name.toString();
                    }
                }
                break;
            case 'states':
                for (let s in this.stateOptions) {
                    if (this.stateOptions[s].id === id) {
                        state = this.stateOptions[s].id;
                    }
                }
                break;
            default:
                return;
        }
        this.setState({ form: { ...form, month, year, state }, errorSelectMonth: '', errorSelectYear: '', errorSelectState: '' });
    };

    private handleCancel = (): void => {
        const { wfs } = this.state;
        Utils.sendMetric(this.props,  METODO_DE_PAGO, `${wfs.gatewaytext.toLowerCase()} - ${CANCELAR_MEDIO_PAGO}`, COMPONENTE_TICKER);
        const { step } = this.state;
        const { history } = this.props;
        if (step === Steps.STEP_CARD) {
            history.goBack();
        } else {
            this.isValidForm = true;
            this.setState({ step: Steps.STEP_CARD });
        }
    };

    @autobind
    private onKeyPress(e: any): void {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        if (currentKey === 'YELLOW') {
            this.handleCancel();
        }
    }

    @autobind
    private onFocus(): void {
        const { element } = this.state;
        onFocusMultipleElements([
            { id: 'card', activeElement: element.id === 'card' },
            { id: 'name', activeElement: element.id === 'name' },
            { id: 'cvv', activeElement: element.id === 'cvv' },
            { id: 'direction', activeElement: element.id === 'direction' },
            { id: 'city', activeElement: element.id === 'city' },
            { id: 'zip', activeElement: element.id === 'zip' },
            { id: 'telephone', activeElement: element.id === 'telephone' }
        ]);
    }

    public render(): JSX.Element {
        const { history, nodes, location: { state: { changeMethod, replace } } } = this.props;
        const {
            step,
            form: { month, year, state, image_card, card:cardValue, name: nameValue, cvv: cvvValue, direction: directionValue, zip: zipValue, city: cityValue, telephone: telephoneValue },
            errors,
            errorSelectYear,
            errorSelectMonth,
            errorSelectState,
            errors: { card, name, cvv, direction, zip, city, telephone },
            isCVV,
            worflowstart,
            pbi,
            type,
            selectedPaymentMethod,
            errorFromBackend,
            isLoading
        } = this.state;
        const formCard = (!isCVV && !changeMethod) || (replace && !changeMethod) || changeMethod;
        if (isLoading) return <Spinner className={cls(`${PAYMENT_CARD}-spinner`)} loadingMessage='' />;
        return (
            <div>
                {formCard && <Grid className={Device.getDevice().getPlatform()}>
                    <HeaderCompound
                        disabled
                        align='right'
                        onClick={this.handleCancel}
                        textBack={Translator.get('top_head_option_button_back', 'REGRESAR')}
                        icon={`${Assets.get('top_head_option_back')}`}
                        onFocus={this.onFocus}
                    />
                    <Row>
                        <Column lg={12}>
                            <Heading size={2} className={cls(`${PAYMENT_CARD}-title`)}>
                                {this.from ? Translator.get('top_head_step_3_label', 'PASO 3 DE 3') : ''}
                            </Heading>
                        </Column>
                    </Row>
                    <Row>
                        <Form id="payment-card-form">
                            <Column lg={6} className={cls(`${PAYMENT_CARD}-column-keyboard`)}>
                                <Keyboard id="Keyboard" onFocus={this.onFocus} filteredFuncion={filterInputValue} />
                            </Column>
                            <Column lg={6} className={cls(`${PAYMENT_CARD}-column-inputs`)}>
                                <Row className={cls(`${PAYMENT_CARD}-row-inputs`)}>
                                    <Column lg={12}>
                                        <Heading size={1} className={cls(`${PAYMENT_CARD}-title-form`)}>
                                            {this.titleForm}
                                        </Heading>
                                    </Column>
                                    {step === Steps.STEP_CARD && (
                                        <Row className={cls(`${PAYMENT_CARD}-column-input`)}>
                                            <Column lg={12}>
                                                <FormInput
                                                    focusWhenMount
                                                    type="numeric"
                                                    id="card"
                                                    name="card"
                                                    placeholder={this.getTextBySteps('placeholderCard')}
                                                    onChange={(e) => this.handleChange(e, 'card')}
                                                    validInput={card}
                                                    errorFromBackend={errorFromBackend}
                                                    maxLength={16}
                                                    onFocus={this.onFocus}
                                                    value={cardValue}
                                                >
                                                    {image_card ? <img className={`${PAYMENT_CARD}-card-type`} src={image_card} alt='card_image' /> : ''}
                                                </FormInput>
                                            </Column>
                                            <Column lg={12}>
                                                <FormInput
                                                    type="text"
                                                    id="name"
                                                    name="name"
                                                    placeholder={this.getTextBySteps('placeholderName')}
                                                    onChange={(e) => this.handleChange(e, 'name')}
                                                    validInput={name}
                                                    errorFromBackend={errorFromBackend}
                                                    error={name}
                                                    onFocus={this.onFocus}
                                                    value={nameValue}
                                                />
                                            </Column>
                                            <Column lg={4} className='month-space'>
                                                {<SelectorButton
                                                    type='month'
                                                    onClick={() => this.handleShowCalendar('months')}
                                                    errorFromBackend={errorSelectMonth}
                                                    error={errors.month}
                                                    className={`${PAYMENT_CARD}-month-button`}
                                                    onFocus={this.onFocus}
                                                >
                                                    {month
                                                        ? this.getMonthString(month)
                                                        : this.getTextBySteps('placeholderMonth')}
                                                    <i className="icon-arrow-down payment" />
                                                </SelectorButton>}
                                            </Column>
                                            <Column lg={4} className='year-space'>
                                                {<SelectorButton
                                                    type='year'
                                                    onClick={() => this.handleShowCalendar('years')}
                                                    errorFromBackend={errorSelectYear}
                                                    error={errors.year}
                                                    className={`${PAYMENT_CARD}-year-button`}
                                                    onFocus={this.onFocus}
                                                >
                                                    {year
                                                        ? year
                                                        : this.getTextBySteps('placeholderYear')}
                                                    <i className="icon-arrow-down payment" />
                                                </SelectorButton>}
                                            </Column>
                                            <Column lg={4} className='cvv-space'>
                                                <FormInput
                                                    type="numeric"
                                                    id="cvv"
                                                    name="cvv"
                                                    placeholder={this.getTextBySteps('placeholderCvv')}
                                                    onChange={(e) => this.handleChange(e, 'cvv')}
                                                    validInput={cvv}
                                                    errorFromBackend={errorFromBackend}
                                                    maxLength={3}
                                                    onFocus={this.onFocus}
                                                    value={cvvValue}
                                                />
                                            </Column>
                                        </Row>
                                    )}
                                    {step === Steps.STEP_DIRECTION && (
                                        <Row className={cls(`${PAYMENT_CARD}-column-input`)}>
                                            <Column lg={12}>
                                                <FormInput
                                                    focusWhenMount
                                                    type="alphanumeric"
                                                    id="direction"
                                                    name="direction"
                                                    placeholder={this.getTextBySteps('placeholderDir')}
                                                    onChange={(e) => this.handleChange(e, 'direction')}
                                                    validInput={direction}
                                                    errorFromBackend={errorFromBackend}
                                                    onFocus={this.onFocus}
                                                    value={directionValue}
                                                />
                                            </Column>
                                            <Column lg={12}>
                                                <FormInput
                                                    type="text"
                                                    id="city"
                                                    name="city"
                                                    placeholder={this.getTextBySteps('placeholderCity')}
                                                    onChange={(e) => this.handleChange(e, 'city')}
                                                    validInput={city}
                                                    errorFromBackend={errorFromBackend}
                                                    onFocus={this.onFocus}
                                                    value={cityValue}
                                                />
                                            </Column>
                                            <Column lg={6} className='state-space'>
                                                {<SelectorButton
                                                    type='state'
                                                    onClick={() => this.handleShowStates()}
                                                    errorFromBackend={errorSelectState}
                                                    error={errors.state}
                                                    className={`${PAYMENT_CARD}-state-button`}
                                                    onFocus={this.onFocus}
                                                >
                                                    {state
                                                        ? this.getStateString(state)
                                                        : this.getTextBySteps('placeholderState')}
                                                    <i className="icon-arrow-down payment" />
                                                </SelectorButton>}
                                            </Column>
                                            <Column lg={6} className='zip-space'>
                                                <FormInput
                                                    type="numeric"
                                                    id="zip"
                                                    name="zip"
                                                    placeholder={this.getTextBySteps('placeholderZip')}
                                                    onChange={(e) => this.handleChange(e, 'zip')}
                                                    validInput={zip}
                                                    maxLength={5}
                                                    errorFromBackend={errorFromBackend}
                                                    onFocus={this.onFocus}
                                                    value={zipValue}
                                                />
                                            </Column>
                                            <Column lg={12} className='telephone-space'>
                                                <FormInput
                                                    type="mobile"
                                                    id="telephone"
                                                    name="telephone"
                                                    placeholder={this.getTextBySteps('placeholderTel')}
                                                    onChange={(e) => this.handleChange(e, 'telephone')}
                                                    validInput={telephone}
                                                    maxLength={getNumberLength()}
                                                    errorFromBackend={errorFromBackend}
                                                    onFocus={this.onFocus}
                                                    value={telephoneValue}
                                                />
                                            </Column>
                                        </Row>
                                    )}
                                    <Column lg={12}>
                                        <Button
                                            activate
                                            type="button"
                                            variant="primary"
                                            disabled={!this.isValidForm}
                                            className={cls(`focusable`, `${PAYMENT_CARD}-button-next`)}
                                            onClick={this.handleNextStep}
                                            onFocus={this.onFocus}
                                            block
                                        >
                                            {this.textNext}
                                        </Button>
                                    </Column>
                                    <Column lg={12} className={cls(`${PAYMENT_CARD}-column-next`)}>
                                        <Button
                                            activate
                                            type="button"
                                            className={cls(
                                                `focusable`,
                                                `${PAYMENT_CARD}-button-cancel`
                                            )}
                                            onClick={this.handleCancel}
                                            onFocus={this.onFocus}
                                            block
                                        >
                                            {this.textCancel}
                                        </Button>
                                    </Column>
                                </Row>
                            </Column>
                        </Form>
                    </Row>
                </Grid>}
                {isCVV && !changeMethod && !replace &&
                    < ConfirmationCVV
                        pbi={pbi}
                        worflowstart={worflowstart}
                        selectedPaymentMethod={selectedPaymentMethod}
                        type={type}
                        history={history}
                        nodes={nodes}
                    />
                }
                {isCVV && changeMethod &&
                    <ChangeCard
                        pbi={pbi}
                        worflowstart={worflowstart}
                        selectedPaymentMethod={selectedPaymentMethod}
                        type={type}
                        history={history} />}
            </div>
        );
    }
}

const mapDispatchToProps = {
    showModal,
    setMetricsEvent
};

export default connect(null, mapDispatchToProps)(PaymentCard);



// WEBPACK FOOTER //
// ./src/payments/ClaroPagosGate/index.tsx